// Tope técnico por archivo al elegirlo (el plan más grande permite 1 GB por envío). El límite real del plan
// se controla ya comprimido: en la app antes de subir, en storage.rules y en el servidor.
export const MAX_FILE_SIZE = 1024 * 1024 * 1024;

// Exocad: .dentalProject, .constructionInfo y .dentalCAD (se comparan en minúsculas).
export const EXOCAD_EXTENSIONS = ["dentalproject", "constructioninfo", "dentalcad"];

export const ALLOWED_EXTENSIONS = ["stl", "ply", "obj", ...EXOCAD_EXTENSIONS, "dcm", "zip", "jpg", "jpeg", "png", "heic", "pdf"];

// Formatos que ya vienen comprimidos: se suben tal cual, sin gzip.
export const ALREADY_COMPRESSED = ["zip", "jpg", "jpeg", "png", "heic", "pdf", "dentalcad"];

export const MODEL_EXTENSIONS = ["stl", "ply", "obj"];

export const ACCEPT_ATTRIBUTE = ALLOWED_EXTENSIONS.map((ext) => `.${ext}`).join(",");

export function getExtension(name = "") {
  const dot = name.lastIndexOf(".");
  return dot === -1 ? "" : name.slice(dot + 1).toLowerCase();
}

export function fileKind(name) {
  const ext = getExtension(name);
  if (MODEL_EXTENSIONS.includes(ext)) return "3d";
  if (EXOCAD_EXTENSIONS.includes(ext)) return "exocad";
  if (["jpg", "jpeg", "png", "heic"].includes(ext)) return "image";
  if (ext === "pdf") return "pdf";
  return "other";
}

// Separa los archivos aceptados de los rechazados, con el motivo.
export function validateFiles(files) {
  const valid = [];
  const rejected = [];
  for (const file of files) {
    if (!ALLOWED_EXTENSIONS.includes(getExtension(file.name))) {
      rejected.push({ name: file.name, reason: "formato no admitido" });
    } else if (file.size > MAX_FILE_SIZE) {
      rejected.push({ name: file.name, reason: `supera ${formatBytes(MAX_FILE_SIZE)}` });
    } else {
      valid.push(file);
    }
  }
  return { valid, rejected };
}

export function fileKey(file) {
  return `${file.webkitRelativePath || file.name}-${file.size}-${file.lastModified}`;
}

// Agrega archivos a la lista evitando duplicados.
export function mergeFiles(current, incoming) {
  const seen = new Set(current.map(fileKey));
  const merged = [...current];
  for (const file of incoming) {
    const key = fileKey(file);
    if (!seen.has(key)) {
      seen.add(key);
      merged.push(file);
    }
  }
  return merged;
}

export function sanitizeFileName(name) {
  return name.normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^\w.-]+/g, "_");
}

export function formatBytes(bytes) {
  if (!bytes) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  const exp = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / 1024 ** exp;
  return `${value.toFixed(value >= 10 || exp === 0 ? 0 : 1)} ${units[exp]}`;
}

// Megabytes con coma decimal, para el mensaje de ahorro.
export function formatMegabytes(bytes) {
  const mb = bytes / (1024 * 1024);
  const digits = mb > 0 && mb < 0.1 ? 2 : 1;
  return `${mb.toLocaleString("es-AR", { minimumFractionDigits: digits, maximumFractionDigits: digits })} MB`;
}

// Entrega bytes al usuario como un archivo descargado con el nombre indicado.
export function saveBytesAs(bytes, name, type) {
  const url = URL.createObjectURL(new Blob([bytes], { type: type || "application/octet-stream" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
